import React, { useState } from "react";
import styled from "styled-components";
import Modal from "react-modal";
import PText from "../components/PText";
import RecomKba from "../assets/images/RecomKba.png";

const SSNotesPagesStyles = styled.div`
  padding: 10rem 0;
  .top-section {
    margin: 4rem 2rem auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    background-color: rgba(0, 255, 0, 0.1);
    padding: 1rem;
  }
  .left {
    flex: 4;
  }
  .right {
    flex: 2;
  }
  .ssnotes__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .my_notes-section {
    width: 100%;
    margin-top: 2rem;
  }
  .kailaba__info {
    margin-bottom: 1rem;
    padding: 1rem;
    .link_button {
      margin-top: 1em;
      padding: 0.5em 2em;
      outline: none;
      border-radius: 5;
    }
    .para {
      max-width: 100%;
    }
  }
  .my_note-info {
    font-size: 1.8rem;
    text-align: justify;
    padding: 0.5rem;
    @media only screen and (max-width: 768px) {
      font-size: 1.4rem;
    }
  }
  .note_info {
    font-size: 1.6rem;
    line-height: 1.6em;
    font-family: poppins, sans-serif;
    color: white;
    margin-bottom: 1rem;
    @media only screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  .all-subjects {
    margin-top: 2rem;
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    .each-subjects {
      flex: 1 1 calc(50% - 1rem);
      padding: 1rem;
      background-color: var(--deep-dark);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 5px;
      margin-top: 1rem;
      margin: auto;
      &:hover {
        transform: translateY(-5px);
      }
      button {
        font-size: 1em;
        cursor: pointer;
        background-color: cyan;
        border: none;
        padding: 0.5rem 1rem;
        border-radius: 5px;
      }
    }
    @media only screen and (max-width: 768px) {
      padding: 0.5rem;
    }
  }
  .thankyou-badge {
    background-color: #ff7e08;
    color: black;
    padding: 0.3rem 0.8rem;
    border-radius: 4px;
    font-size: 1.4rem;
    font-weight: 500;
    @media only screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  .subject-info {
    font-size: 1.6rem;
    line-height: 1.2em;
    font-family: poppins, sans-serif;
    color: white;
    @media only screen and (max-width: 768px) {
      font-size: 1.4rem;
    }
  }
`;

const ModalStyles = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  .modal-content {
    width: 95%;
    height: 80%;
    background: white;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  .close-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 16px;
    font-width: bold;
    background: black;
    color: white;
    border: none;
    padding: 3px 8px;
    border-radius: 50%;
    cursor: pointer;
  }
  iframe {
    flex: 1;
    width: 100%;
    height: 100%;
  }
`;

const subject_lists = [
  {
    id: 1,
    name: "Discrete Structure",
    // link: "https://docs.google.com/presentation/d/1S1gzmiReKHYK4vWYTo8x8ry-BXH9pdXmItot8JUIPjU/edit?usp=sharing"
    link: "https://docs.google.com/presentation/d/e/2PACX-1vRLh_gQuHyGZcfpcUJFJEo_Fol79wQEKSYTcOvM3yFddTJNH-H3eb0ZmTESHmJLpR3gZ1IPry4KCCeK/pubembed?start=true&loop=true&delayms=60000",
  },
  {
    id: 2,
    name: "Computer Architecture",
    link: "https://docs.google.com/presentation/d/e/2PACX-1vS_CFrdi_5M0bKZHyL6YOQIShS0FuOBszJtwm55ZNyviZcj1ksku_95dBB0-3UjJB9WY66IGNbpZXHy/pubembed?start=true&loop=true&delayms=60000",
  },
  {
    id: 3,
    name: "Artificial Intelligence",
    // link: "https://www.canva.com/design/DAGI6YA0DJ4/ZlA-8hI45PVvLUP58FdS_A/view?utm_content=DAGI6YA0DJ4&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=h9361483cbf"
    // link:"https://sujansharma-ai.my.canva.site/",
    link: "https://www.canva.com/design/DAGI6YA0DJ4/VbVJJo8YZ-iK6L5ibht_Xg/view?embed",
  },
  {
    id: 4,
    name: "Computer Graphics",
    link: "https://www.canva.com/design/DAFveAWFUd0/soz-gLLnEQlHEd1MDghd_A/view?embed",
  },
  {
    id: 5,
    name: "Introduction to IT & Application",
    link: "https://docs.google.com/presentation/d/e/2PACX-1vRTl4cYMtn7qRs5lMDeQFQBVnXJxgVkyB4DQqbp1c27e1MNBqfrohyVJSPVq00XeeIPlDoG0kb59Z-A/pubembed?start=true&loop=true&delayms=60000",
  },
  {
    id: 6,
    name: "Image Processing",
    link: "https://docs.google.com/presentation/d/e/2PACX-1vS7eyv3dt9BoKf0Be3Jq501n-4H4piJKEcr56EXCIMxTBc5Fo5jyPmmKE3jorUhHWUWAEm9oTakmfML/pubembed?start=true&loop=true&delayms=60000",
  },
  {
    id: 7,
    name: "Information Retrieval",
    link: "https://docs.google.com/presentation/d/e/2PACX-1vS52srRjGzFNRsd4Am7OmScceezVU3nzSS0J69-qbEif1-dpsNvernIJxf6kVbkxU6eBcV3VtGVZR0G/pubembed?start=true&loop=true&delayms=60000",
  },
];

export default function SSNotes() {
  const [selectedSlide, setSelectedSlide] = useState(null);

  return (
    <>
      <SSNotesPagesStyles>
        <div className="container">
          <h2 className="ssnotes__heading">Sujan Sir Ko Notes</h2>
          <span className="thankyou-badge">Thanks for visiting this page</span>
          <div className="my_notes-section">
            <h3 className="my_note-info">
              I served as a{" "}
              <span style={{ color: "cyan" }}>Part Time Faculty</span> Lecturer
              at
              <span style={{ color: "cyan" }}>
                {"  "}
                St. Xavier's College (TU)
              </span>{" "}
              from
              <span style={{ color: "cyan" }}>
                {" "}
                January 2025 to August 2025
              </span>
              , teaching
              <span style={{ color: "cyan" }}> Image Processing</span> and
              <span style={{ color: "cyan" }}> Information Retrieval</span>.
              <br />
              <br />
              Also I worked as a{" "}
              <span style={{ color: "cyan" }}>Visiting Faculty</span> Lecturer
              at
              <span style={{ color: "cyan" }}> Vedas College (TU)</span> from
              <span style={{ color: "cyan" }}> May 2023 to October 2025</span>,
              where I taught several other undergraduate(Bsc.CSIT, BCA, BBM)
              courses.
            </h3>
            <br></br>
            <br></br>

            <p
              className="subject-info"
              style={{ textAlign: "left", padding: "0.5rem" }}
            >
              Here are the subjects I taught.
            </p>

            <div className="all-subjects">
              {subject_lists.map((item) => (
                <div className="each-subjects" key={item.id}>
                  <PText>
                    {item.name}
                    {item.id > 6 && (
                      <sup
                        style={{
                          backgroundColor: "#ff7e08",
                          color: "black",
                          padding: "0.1rem 0.3rem",
                          borderRadius: "0.2rem",
                          marginLeft: "0.3rem",
                          fontSize: "0.8rem",
                        }}
                      >
                        Populer
                      </sup>
                    )}
                  </PText>
                  <button
                    style={{ color: "black" }}
                    onClick={() => setSelectedSlide(item.link)}
                  >
                    View
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="top-section">
            <div className="left">
              <div className="kailaba__info">
                <p className="note_info">
                  For All Engineering Notes and Resources, I prefer to visit
                  Kailaba.com
                  <br />
                </p>
                <button className="link_button">
                  <a
                    href="https://kailaba.com/engineering-notes-kailaba/"
                    style={{ color: "black", fontSize: "1rem" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit Kailaba
                  </a>
                </button>
              </div>
            </div>
            <div className="right">
              <img src={RecomKba} alt="Recommended Notes" />
            </div>
          </div>
        </div>
      </SSNotesPagesStyles>

      {/* Modal */}
      <ModalStyles
        isOpen={!!selectedSlide}
        onRequestClose={() => setSelectedSlide(null)}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
      >
        <div className="modal-content">
          <button className="close-btn" onClick={() => setSelectedSlide(null)}>
            X
          </button>
          {selectedSlide && (
            <iframe
              src={selectedSlide}
              title="Google Slides"
              frameborder="0"
              width="960"
              height="569"
              allowfullscreen="true"
              mozallowfullscreen="true"
              webkitallowfullscreen="true"
            ></iframe>
          )}
        </div>
      </ModalStyles>
    </>
  );
}
